'use client';

import { TheaterShowtimeItem } from '@/types/showtimes';
import { commonFetch, CommonFetchResponse } from '@/utils/common-fetch';
import { buildUrlWithParams } from '@/utils/url-params';

type GetShowtimesRequest = {
  date?: Date;
  movieIds?: number[];
  theaterId: number;
  timeZone?: string;
};

class TheaterShowtimesApiService {
  async getAvailableDates(theaterId: number, timeZone?: string, signal?: AbortSignal): Promise<CommonFetchResponse<string[]>> {
    const url = `/papi/theaters/${theaterId}/showtime-dates`;
    return await commonFetch<string[]>(
      buildUrlWithParams(url, timeZone ? { timeZone } : {}),
      signal ? { signal } : undefined
    );
  }

  async getShowtimes(request: GetShowtimesRequest, signal?: AbortSignal): Promise<CommonFetchResponse<TheaterShowtimeItem[]>> {
    const params: Record<string, unknown> = {};

    if (request.date) {
      const year = request.date.getFullYear();
      const month = String(request.date.getMonth() + 1).padStart(2, '0');
      const day = String(request.date.getDate()).padStart(2, '0');
      params.date = `${year}-${month}-${day}`;
    }
    if (request.timeZone) {
      params.timeZone = request.timeZone;
    }

    if (request.movieIds && request.movieIds.length) {
      params.movieIds = request.movieIds.join(',');
    }

    const url = `/papi/theaters/${request.theaterId}/showtimes`;
    const response = await commonFetch<TheaterShowtimeItem[]>(buildUrlWithParams(url, params), signal ? { signal } : undefined);
    return response;
  }
}

export const theaterShowtimesApiService = new TheaterShowtimesApiService();
